import React from "react";
import ChatGPTTypingEffect from "../../../utils/ChatGPTTyping";
import Nav from "../../../assets/svg/icon1.svg";
import cha from "../../../assets/svg/Cha1.svg";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MessageList = ({
  chatConversation,
  isNewAnswer,
  answerLoading,
  endRef,
  modelSelect,
  onSuggestedPrompt,
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    if (isNaN(d)) return "";
    return d
      .toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\bam\b/gi, "AM")
      .replace(/\bpm\b/gi, "PM");
  };

  const formatJustDate = (dateString) => {
    if (!dateString) return "";
    let d = new Date(dateString);
    if (isNaN(d) && typeof dateString === "string") {
      d = new Date(dateString.replace(",", ""));
    }
    if (isNaN(d))
      return typeof dateString === "string"
        ? dateString.split(",")[0].trim()
        : "";
    return d.toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (dateString) => {
    if (!dateString) return "";
    let d = new Date(dateString);
    if (isNaN(d) && typeof dateString === "string") {
      d = new Date(dateString.replace(",", ""));
    }
    if (isNaN(d)) {
      if (typeof dateString === "string") {
        const parts = dateString.split(",");
        return parts.length > 1 ? parts[parts.length - 1].trim() : dateString;
      }
      return "";
    }
    return d
      .toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\bam\b/gi, "AM")
      .replace(/\bpm\b/gi, "PM");
  };

  return (
    <>
      {chatConversation && chatConversation.length > 0 ? (
        (() => {
          let lastSeenDate = "";
          return chatConversation.map((chat, index) => {
            const rawDate = chat.date || chat.dateAt;
            const justDate = formatJustDate(rawDate);
            const timeStr = formatTime(rawDate);

            let showDateDivider = false;
            if (justDate && justDate !== lastSeenDate) {
              showDateDivider = true;
              lastSeenDate = justDate;
            }

            return (
              <div
                key={"chat" + index}
                style={{ width: "100%", marginTop: "10px" }}
              >
                {showDateDivider && justDate && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      margin: "20px 0",
                    }}
                  >
                    <div
                      style={{ flex: 1, borderBottom: "1px solid #E2E8F0" }}
                    ></div>
                    <span
                      style={{
                        margin: "0 15px",
                        color: "#66737E",
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      {justDate}
                    </span>
                    <div
                      style={{ flex: 1, borderBottom: "1px solid #E2E8F0" }}
                    ></div>
                  </div>
                )}

                {(chat.question || chat.questionImage) && (
                  <div
                    className="d-flex justify-content-end"
                    style={{
                      gap: "8px",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        maxWidth: "60%",
                      }}
                    >
                      <div
                        style={{
                          borderRadius: "20px 20px 4px 20px",
                          backgroundColor: "#EAF4FF",
                          padding: "10px 12px",
                          fontWeight: "400",
                          color: "091E42",
                          fontSize: "14px",
                          maxWidth: "100%",
                          wordBreak: "break-word",
                          marginBottom: "10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        {chat.questionImage && (
                          <img
                            src={chat.questionImage}
                            alt="Uploaded"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "250px",
                              borderRadius: "12px",
                              display: "block",
                            }}
                          />
                        )}
                        {chat.question &&
                          (typeof chat.question === "string" ? (
                            chat.question.startsWith("data:image/") ? (
                              <img
                                src={chat.question}
                                alt="Captured"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "250px",
                                  borderRadius: "12px",
                                  display: "block",
                                }}
                              />
                            ) : (
                              <span>{chat.question}</span>
                            )
                          ) : (
                            chat.question
                          ))}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "end",
                          justifyContent: "flex-end",
                          gap: "6px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "#98A180",
                        }}
                      >
                        {timeStr}{" "}
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#98A180",
                          }}
                        >
                          .
                        </span>{" "}
                        <span
                          style={{
                            fontWeight: "700",
                            fontSize: "11px",
                            color: "#0066CC",
                          }}
                        >
                          You
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {(chat.answer || (chat.data && chat.data.length > 0)) && (
                  <div
                    className="d-flex"
                    style={{ gap: "8px", marginBottom: "20px" }}
                  >
                    <div>
                      <img
                        src={Nav}
                        style={{ width: "32px", height: "32px" }}
                        alt="bot avatar"
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        maxWidth:
                          chat.data && chat.data.length > 0 ? "90%" : "60%",
                        width:
                          chat.data && chat.data.length > 0 ? "100%" : "auto",
                      }}
                    >
                      <div
                        style={{
                          borderRadius: "20px 20px 20px 4px",
                          backgroundColor: "#F2F2F2",
                          padding: "10px 12px",
                          fontWeight: "400",
                          color: "#091E42",
                          fontSize: "14px",
                          marginBottom: "10px",
                          maxWidth: "100%",
                          wordBreak: "break-word",
                          width:
                            chat.data && chat.data.length > 0 ? "100%" : "auto",
                        }}
                      >
                        {chat.answer &&
                          (chatConversation.length - 1 !== index ||
                            !isNewAnswer) && (
                            <ReactMarkdown
                              remarkPlugins={[remarkGfm]}
                              components={{
                                table: ({ node, ...props }) => (
                                  <div className="table-responsive mt-3">
                                    <table
                                      className="table table-bordered table-striped bg-white"
                                      style={{
                                        fontSize: "13px",
                                        marginBottom: 0,
                                        whiteSpace: "normal",
                                      }}
                                      {...props}
                                    />
                                  </div>
                                ),
                                p: ({ node, ...props }) => (
                                  <p style={{ marginBottom: 0 }} {...props} />
                                ),
                              }}
                            >
                              {chat.answer}
                            </ReactMarkdown>
                          )}
                        {chat.answer &&
                          chatConversation.length - 1 === index &&
                          isNewAnswer && (
                            <ChatGPTTypingEffect text={chat.answer} />
                          )}

                        {chat.data && chat.data.length > 0 && (
                          <div className="table-responsive mt-3">
                            <table
                              className="table table-bordered table-striped bg-white"
                              style={{
                                fontSize: "13px",
                                marginBottom: 0,
                                whiteSpace: "nowrap",
                              }}
                            >
                              <thead>
                                <tr>
                                  {Object.keys(chat.data[0]).map((key, idx) => (
                                    <th key={idx}>
                                      {key
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (char) =>
                                          char.toUpperCase(),
                                        )}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {chat.data.map((item, rowIdx) => (
                                  <tr key={rowIdx}>
                                    {Object.keys(chat.data[0]).map(
                                      (key, colIdx) => {
                                        const value = item[key];
                                        const isDate =
                                          key === "created_at" ||
                                          key === "updated_at" ||
                                          key === "deleted_at";

                                        const isLongText =
                                          key === "title" ||
                                          key === "description" ||
                                          key === "address";

                                        let displayValue = value;
                                        if (isDate && value) {
                                          displayValue = formatDate(value);
                                        }

                                        if (isLongText) {
                                          return (
                                            <td
                                              key={colIdx}
                                              dangerouslySetInnerHTML={{
                                                __html: value || "",
                                              }}
                                              style={{
                                                whiteSpace: "normal",
                                                minWidth: "250px",
                                              }}
                                            ></td>
                                          );
                                        }

                                        if (
                                          typeof displayValue === "object" &&
                                          displayValue !== null
                                        ) {
                                          displayValue =
                                            JSON.stringify(displayValue);
                                        }

                                        return (
                                          <td key={colIdx}>
                                            {displayValue !== null &&
                                            displayValue !== undefined
                                              ? String(displayValue)
                                              : ""}
                                          </td>
                                        );
                                      },
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "end",
                          justifyContent: "flex-start",
                          gap: "6px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "#98A180",
                        }}
                      >
                        {timeStr}{" "}
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#98A180",
                          }}
                        >
                          .
                        </span>{" "}
                        <span
                          style={{
                            fontWeight: "700",
                            fontSize: "11px",
                            color: "#0066CC",
                          }}
                        >
                          Bot
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                <div ref={endRef} />
              </div>
            );
          });
        })()
      ) : (
        <div className="empty-chat-container">
          <div className="empty-chat-logo-wrap">
            <img
              src={cha}
              alt="chat bot avatar"
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                objectFit: "contain",
              }}
            />
          </div>
          <h2 className="empty-chat-title">How can I help you today?</h2>
          <p className="empty-chat-subtitle">
            Ask me anything — from ticket summaries to reports. I'm here to
            help.
          </p>
          <div className="empty-chat-suggestions">
            <button
              className="suggestion-pill"
              type="button"
              onClick={() => onSuggestedPrompt?.("Show my recent tickets")}
            >
              Show my recent tickets
            </button>
            <button
              className="suggestion-pill"
              type="button"
              onClick={() => onSuggestedPrompt?.("Want to create new leads")}
            >
              Want to create new leads
            </button>
            <button
              className="suggestion-pill"
              type="button"
              onClick={() => onSuggestedPrompt?.("What can you help me with?")}
            >
              What can you help me with?
            </button>
            <button
              className="suggestion-pill"
              type="button"
              onClick={() => onSuggestedPrompt?.("Summarize today's activity")}
            >
              Summarize today's activity
            </button>
          </div>
        </div>
      )}

      {answerLoading && (
        <div
          className="d-flex"
          style={{
            gap: "8px",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          <div>
            <img
              src={Nav}
              style={{ width: "32px", height: "32px" }}
              alt="bot"
            />
          </div>
          <div
            style={{
              borderRadius: "20px 20px 20px 4px",
              backgroundColor: "#F2F2F2",
              padding: "14px 18px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span className="typing-dot" style={{ animationDelay: "0ms" }} />
            <span className="typing-dot" style={{ animationDelay: "160ms" }} />
            <span className="typing-dot" style={{ animationDelay: "320ms" }} />
          </div>
        </div>
      )}
      <div ref={endRef} />
    </>
  );
};

export default MessageList;
